import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import GlobalLogs from "./log_tabs/GlobalLogs";
import UserLogs from "./log_tabs/UserLogs";
import TypeLogs from "./log_tabs/TypeLogs";
import LogSettings from "./log_tabs/LogSettings";

//Deps
import { Paper, Tab, Tabs, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

//Icons
import LanguageIcon from "@material-ui/icons/Language";
import GroupIcon from "@material-ui/icons/Group";
import ClassIcon from "@material-ui/icons/Class";
import SettingsIcon from "@material-ui/icons/Settings";

function mapStateToProps(state) {
  return {
    state
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Tab container
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: "1em" }}>
      {props.children}
    </Typography>
  );
}

//Styles
const styles = theme => ({
  root: {
    width: "100%"
  },
  paper: {
    width: "100%",
    paddingTop: "1em"
  },
  icon: {
    paddingBottom: "10px"
  },
  container: {
    padding: "2em"
  },
  key: {
    fontSize: "1.5em",
    fontWeight: "bold",
    marginTop: "1em"
  }
});

class ClientLogPage extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Tabs value={this.state.value} onChange={this.handleChange} fullWidth indicatorColor="secondary" textColor="secondary">
            <Tab icon={<LanguageIcon />} className={classes.icon} />
            <Tab icon={<GroupIcon />} className={classes.icon} />
            <Tab icon={<ClassIcon />} className={classes.icon} />
            <Tab icon={<SettingsIcon />} className={classes.icon} />
          </Tabs>
        </Paper>
        <div className={classes.container}>
          {this.state.value === 0 && (
            <TabContainer>
              <GlobalLogs />
            </TabContainer>
          )}
          {this.state.value === 1 && (
            <TabContainer>
              <UserLogs />
            </TabContainer>
          )}
          {this.state.value === 2 && (
            <TabContainer>
              <TypeLogs />
            </TabContainer>
          )}
          {this.state.value === 3 && (
            <TabContainer>
              <LogSettings />
            </TabContainer>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ClientLogPage));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/ClientLogPage.js